'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixAst = fixAst;

var _functions = require('./functions');

var _blocks = require('./blocks');

var _is = require('./is');

// Perform non-semantic AST transformations like ensuring function bodies
// are blocks, etc.
function fixAst(programPath) {
  return programPath.traverse({
    Method(path) {
      var node = path.node;

      if ((0, _functions.isNamedArrowFunction)(node)) {
        node.body = (0, _blocks.toBlockStatement)(node.body);
        path.replaceWith(node);
      }
    }, SafeMemberExpression(path) {
      if ((0, _is.isa)(path.parent, "ArrowFunctionExpression")) {
        (0, _functions.ensureBlockArrowFunctionExpression)(path.parentPath);
      }
    } });
}